import React, { useEffect, useCallback, useState} from 'react';
import {freezeInstrument} from "track/freeze/FreezeInstrument.js";
import {
    TRACK_ADD_STEPS_BUTTON,
    TRACK_REMOVE_STEPS_BUTTON,
    TRACK_LENGTH_BUTTON,
    FREEZE_BUTTON,
} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import {MIDI} from 'constants/track-types.js';
import {freezePatterns} from './trackRightClickActions.js';
import TrackDirectionButton from './TrackDirectionButton.js';
import {connect} from 'react-redux';
import Resolution from 'engine/Resolution.js';
import {setTrackToFreeze} from 'actions/index.js';

const BASE_RESOLUTION = new Resolution(32, false);

const TrackFooter = ({
    track,
    trackColor,
    trackLengthMode,
    setTrackLengthMode,
    resolution,
    isSelectedTrack,
    setTrackToFreeze,
    children
}) => { 
    let {sequencerEngine} = track;

    let stepsButtonStyle = {};
    if (isSelectedTrack) {
        stepsButtonStyle = {
            backgroundColor: trackColor,
            color: "black"
        };
    };
    
    let lengthModeButtonClass = "track-length-button";
    if (trackLengthMode) {
        lengthModeButtonClass += " selected";
    }

    const onClickTrackLengthMode = useCallback(() => {
        if (trackLengthMode) {
            // then get the size from the state
            let len = BASE_RESOLUTION.transformStepAtResolution(
                track.sequencerEngine.state.tracks.trackLengthChoice,
                resolution);
            track.pattern.changeLength(len);
        }
        setTrackLengthMode(!trackLengthMode);
    }, [trackLengthMode, track, resolution]);
    
    return (
        <div className="track-footer-container">
          <Documented element={TRACK_ADD_STEPS_BUTTON}>
            <div
              style={stepsButtonStyle}
              onClick={() => sequencerEngine.doubleTrackLength(track.trackNumber)}
              
              className="add-steps-button">
              +
            </div>
          </Documented>
          <Documented element={TRACK_REMOVE_STEPS_BUTTON}>
            <div
              style={stepsButtonStyle}
              onClick={() => sequencerEngine.halfTrackLength(track.trackNumber)}
              className="remove-steps-button">
              -
            </div>
          </Documented>
          <Documented element={TRACK_LENGTH_BUTTON}>
            <div
              style={stepsButtonStyle}
              onClick={onClickTrackLengthMode}
              className={lengthModeButtonClass}>
              Len.
            </div>
          </Documented>
          {children}
          <TrackDirectionButton
            isSelected={isSelectedTrack}
            color={trackColor}
            track={track}/>
          <Documented element={FREEZE_BUTTON}>
            <div
              style={{
                  backgroundColor: trackColor
              }}
              onClick={
                  (e) => {
                      if (e.metaKey) {
                          e.stopPropagation();
                          e.preventDefault();
                          freezeInstrument(sequencerEngine);
                      } else if (track.getTrackType() === MIDI) {
                          track.masterResampler.prepare();
                          setTrackToFreeze();
                      } else {
                          freezePatterns(track);
                      }
                  }
              }
              className="freeze-button dot">
            </div>
          </Documented>
        </div>
    );
}

const mapDispatchToProps = (dispatch, props) => {
    return {
         setTrackToFreeze: () => dispatch(setTrackToFreeze(props.track.subSequence.id, props.track.trackNumber)),
    };
};


export default connect(null, mapDispatchToProps)(TrackFooter);
